import { IconButton } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { TableCommunication } from '../TableCommunication';
import React from 'react';
import { useInjection } from './hook';
import { CommunicationUpdate, fileResCommunication, TDateCommunication } from '../../type';
import { Lead } from 'types/user';
export type UpdateTabProps = {
  initData: CommunicationUpdate;
  handleChangeDate: ({
    endDate,
    startDate
  }: {
    startDate?: string | null;
    endDate?: string | null;
  }) => void;
  dateSearch: TDateCommunication | null;
  handleCopyAllUpdates?: (fileInfo?: fileResCommunication) => void;
  onRefreshTabSeizureReport: () => void;
  handleDeleteNote: ({ idNote, lead }: { idNote: number; lead?: Partial<Lead> }) => void;
};
export const SeizureReportTab = ({
  initData,
  handleChangeDate,
  dateSearch,
  handleCopyAllUpdates,
  handleDeleteNote,
  onRefreshTabSeizureReport
}: UpdateTabProps) => {
  const {
    dataRow,
    hasMore,
    fetchMoreData,
    dataClientSelected,
    setDataClientSelected,
    handleDeleteReport
  } = useInjection({ initData, dateSearch, onRefreshTabSeizureReport });

  return (
    <TableCommunication
      isReport
      handleDeleteNote={(value) => {
        handleDeleteNote(value);
      }}
      handleDeleteReport={handleDeleteReport}
      dataClientSelected={dataClientSelected}
      setDataClientSelected={setDataClientSelected}
      headers={[
        { label: 'Debtor Name', width: 120 },
        { label: 'Seize Date', width: 120 },
        { label: 'Seized Address', width: 120 },
        { label: 'Customers POR', width: 120 },
        { label: 'Removed to', width: 120 },
        { label: 'KM', width: 120 },
        { label: 'Keys', width: 80 },
        { label: 'Runs', width: 80 },
        { label: 'Possible Redemption', width: 80 },
        { label: 'Condition Report', width: 120 },
        { label: 'Towing company used', width: 120 },
        { label: 'Transport required', width: 120 },
        { label: 'Other bills incurred', width: 120 },
        {
          label: (
            <>
              <IconButton sx={{ padding: '0 8px 0 0' }}>
                <ContentCopyOutlinedIcon />
              </IconButton>
              Copy all
            </>
          ),
          width: 120,
          onClick: () => handleCopyAllUpdates && handleCopyAllUpdates(dataClientSelected)
        }
      ]}
      hasMore={hasMore}
      fetchMoreData={fetchMoreData}
      label={'Seizure Reports'}
      rows={dataRow}
      handleChangeDate={(startDate?: string | null, endDate?: string | null) => {
        handleChangeDate({ startDate, endDate });
        setDataClientSelected(undefined);
      }}
      date={dateSearch}
    />
  );
};
